module.exports = __webpack_public_path__ + "static/img/wh-101.fdc56d0e.png";